module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/col-right-da5ccdeb4f342e2ce13ae9c5241728ef.svg";